import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import React, { useState } from 'react';
import { Specifications } from './modal';
import Specstile from './measurementUnitSelectionSwitch';

interface ISpecificationDataProps {
	specifications: Specifications;
}

const SpecificationData = (props: ISpecificationDataProps) => {
	const { data, label } = props.specifications;
	const [specificationUnit, setSpecificationUnit] = useState('cm');

	return (
		<FlexBox
			direction='column'
			sx={{ paddingLeft: '24px', justifyContent: 'start' }}
		>
			<FlexBox sx={{ justifyContent: 'start' }}>
				<LencoTypography
					sx={{
						...getStyle('H9_Medium'),
						color: getColor('Gray 0'),
						paddingRight: '16px',
					}}
				>
					{label}
				</LencoTypography>
				<Specstile
					setSpecificationUnit={setSpecificationUnit}
					specificationUnit={specificationUnit}
				/>
			</FlexBox>
			<FlexBox direction='column' sx={{ justifyContent: 'start' }}>
				{data.map((specs, index) => {
					return (
						<>
							<FlexBox
								key={specs.type}
								direction='column'
								sx={{ paddingBottom: '24px', paddingTop: '24px' }}
							>
								<LencoTypography
									sx={{
										...getStyle('H14_SemiBold'),
										color: getColor('Gray -1'),
									}}
								>
									{specs.type}
								</LencoTypography>
								{specs.data.map((specsInfo, index) => {
									return (
										<FlexBox key={specsInfo.key}>
											<LencoTypography
												sx={{
													...getStyle('P_Regular'),
													color: getColor('Gray -1'),
													whiteSpace: 'nowrap',
												}}
											>
												{specsInfo.key} :{' '}
											</LencoTypography>
											<LencoTypography
												sx={{
													...getStyle('P_Medium'),
													color: getColor('Gray -1'),
													paddingLeft: '8px',
												}}
											>
												{typeof specsInfo.value == 'string'
													? specsInfo?.value
													: specsInfo?.value?.filter((x: any) => {
															return x.unit == specificationUnit;
													  })[0]?.value}
											</LencoTypography>
										</FlexBox>
									);
								})}
							</FlexBox>
							{index < data.length - 1 && (
								<Box
									sx={{ borderTop: `1px dashed ${getColor('Gray -3')}` }}
								></Box>
							)}
						</>
					);
				})}
			</FlexBox>
		</FlexBox>
	);
};

export default SpecificationData;
